import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeTab: 'dashboard',
  showBalances: true,
  sidebarCollapsed: false,
  theme: 'light',
  notifications: [],
  modals: {
    subscription: false,
    addTransaction: false,
    addGoal: false,
    reward: false,
    confirmation: false,
  },
  rewardData: null,
  confirmationData: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    toggleBalances: (state) => {
      state.showBalances = !state.showBalances;
    },
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.push({
        id: Date.now().toString(),
        ...action.payload,
        timestamp: new Date().toISOString(),
      });
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(n => n.id !== action.payload);
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    openModal: (state, action) => {
      state.modals[action.payload] = true;
    },
    closeModal: (state, action) => {
      state.modals[action.payload] = false;
    },
    closeAllModals: (state) => {
      Object.keys(state.modals).forEach(key => {
        state.modals[key] = false;
      });
    },
    showReward: (state, action) => {
      state.modals.reward = true;
      state.rewardData = action.payload || null; // { title, message, points }
    },
    hideReward: (state) => {
      state.modals.reward = false;
      state.rewardData = null;
    },
    showConfirmation: (state, action) => {
      state.modals.confirmation = true;
      state.confirmationData = action.payload || null; // { title, message, confirmText, cancelText, variant, icon, onConfirm }
    },
    hideConfirmation: (state) => {
      state.modals.confirmation = false;
      state.confirmationData = null;
    },
  },
});

export const {
  setActiveTab,
  toggleBalances,
  toggleSidebar,
  setTheme,
  addNotification,
  removeNotification,
  clearNotifications,
  openModal,
  closeModal,
  closeAllModals,
  showReward,
  hideReward,
  showConfirmation,
  hideConfirmation,
} = uiSlice.actions;

export default uiSlice.reducer;